// extracted by mini-css-extract-plugin
export default {"section":"Section_section__fGsU2","sectionContainer":"Section_sectionContainer__HKDuS"};